import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: './start.component.html'
})

export class StartComponent implements OnInit {

  constructor() {
  	
  }

  ngOnInit() {
  	
  }

}


// WEBPACK FOOTER //
// ./src/app/view/start/start.component.ts